import React from "react";
import classes from "./Intro.module.css";
import Container from "../../UI/Container/Container";
import image from '../../../assets/images/global-intro--resized.jpg'
import mist from '../../../assets/images/mist.png'

const GlobalOpportunities = (props) => {
  return (
    <div className={classes.Intro}>
      <img src={image} alt="Mountains in Harman, NZ" />
      <div className={classes.MistLayer}>
        <img className={classes.Mist} src={mist} alt="mist" aria-hidden="true" />
      </div>
      <div className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <h1>Our Global Opportunities</h1>
          </div>
        </Container>
      </div>
 
    </div>
  );
};

export default GlobalOpportunities;
